"use client";

import { snakize } from "@repo/edtech-shared";
import useSWRMutation from "swr/mutation";

import { API_URLS } from "./constants";
import { fetcher } from "./utils";

type AgreementInfo = {
  unit: string,
  publication: string,
  material: string,
  type: string,
  actionTarget: string,
  agreementText: string,
};

type ValidateCodeRequest = {
  action: string,
  code: string,
  agreementInfo: AgreementInfo,
};

export enum ValidateCodeCase {
  Valid = 0,
  NotFound = 1,
  Invalid = 2,
  TooManyAttempts = 3,
}

type ValidateCodeResponse = {
  case: ValidateCodeCase,
};

type ValidateCodeResult = {
  isValid: boolean,
  case: ValidateCodeCase,
  errorMessage?: string,
};

export const ERROR_MESSAGES: Record<ValidateCodeCase, string | undefined> = {
  [ ValidateCodeCase.Valid ]: undefined,
  [ ValidateCodeCase.NotFound ]: "Код не найден. Запросите новый код.",
  [ ValidateCodeCase.Invalid ]: "Неверный код. Попробуйте ещё раз.",
  [ ValidateCodeCase.TooManyAttempts ]: "Превышено количество попыток. Запросите новый код.",
};

export const useValidateCode = () => {
  return useSWRMutation(API_URLS.CODES_VALIDATE,
    async (_url, { arg }: { arg: ValidateCodeRequest }): Promise<ValidateCodeResult> => {
      const res = await fetcher<ValidateCodeResponse>({
        url: API_URLS.CODES_VALIDATE,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(snakize(arg)),
      });

      return {
        isValid: res.case === ValidateCodeCase.Valid,
        case: res.case,
        errorMessage: ERROR_MESSAGES[ res.case ],
      };
    });
};
